<template>
  <div v-if="subtestAttempt">
    <div class="row overflow-hidden-row">
      <div class="col-sm-3">
        <div class="img-style">
          <img :src="subtestAttempt.subtest.image_path" alt="">
        </div>
      </div>
      <div class="col-sm-9">
        <div class="date-block-img-wrapper">
          <div class="img-wrapper-av shadow-sm">
            <img :src="subtestAttempt.subtest.test_type.icon_path"
                 :alt="subtestAttempt.subtest.test_type.name">
          </div>

          <div class="info-block shadow-sm" v-if="subtestAttempt.speaking_appointment_at">
            <div class="text-center">
              <p class="year font-weight-bold mb-0">{{ speakingDateDay }}</p>
              <p class="font-weight-bolder mb-0 text-left">{{ speakingDateMonth }}</p>
              <p class="font-weight-light mb-0 text-left">{{ speakingDateYear }}</p>
            </div>
            <div>
              <div class="font-weight-bolder mb-0">
                {{ speakingDateHours }}
              </div>
            </div>
          </div>

          <div class="info-block shadow-sm" v-if="subtestAttempt.payment">
            <div>
              <p class="info-block-md">Bestellung:
                #{{ subtestAttempt.payment.payment_id }}</p>
              <p class="info-block-sm">
                <b>{{ subtestAttempt.payment.created_at | date }}</b>
              </p>
            </div>
          </div>
        </div>

        <h2>{{ translate('subtest-attempt.course_of_test') }}</h2>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <number-icon :number="1"></number-icon>
            {{ translate('subtest-attempt.' + subtestAttempt.subtest.subtest_type.name + '_steps.step_1') }}
          </li>
          <li class="list-group-item">
            <number-icon :number="2"></number-icon>
            {{ translate('subtest-attempt.' + subtestAttempt.subtest.subtest_type.name + '_steps.step_2') }}
          </li>
          <li class="list-group-item">
            <number-icon :number="3"></number-icon>
            {{ translate('subtest-attempt.' + subtestAttempt.subtest.subtest_type.name + '_steps.step_3', { date: writingDeadline }) }}
          </li>
          <li v-if="subtestAttempt.subtest.subtest_type.name === 'complete'"
              class="list-group-item list-group-item-info">
            <i class="fa fa-info-circle"></i> {{ translate('subtest-attempt.complete_steps.note') }}
          </li>
          <li class="list-group-item">
            <number-icon :number="4"></number-icon>
            {{ translate('subtest-attempt.' + subtestAttempt.subtest.subtest_type.name + '_steps.step_4') }}
          </li>
          <li v-if="subtestAttempt.subtest.subtest_type.name === 'complete'" class="list-group-item">
            <number-icon :number="5"></number-icon>
            {{ translate('subtest-attempt.complete_steps.step_5') }}
          </li>
          <li v-if="subtestAttempt.subtest.subtest_type.name === 'complete'" class="list-group-item">
            <number-icon :number="6"></number-icon>
            {{ translate('subtest-attempt.complete_steps.step_6') }}
          </li>
          <li v-if="subtestAttempt.subtest.subtest_type.name === 'complete'" class="list-group-item">
            <number-icon :number="7"></number-icon>
            {{ translate('subtest-attempt.complete_steps.step_7') }}
          </li>
        </ul>
        <h6>{{ translate('subtest-attempt.good_luck') }}</h6>

        <div class="alert alert-success" role="alert"
             v-if="(uploadReadingFileForm.successful && uploadListeningFileForm.successful && uploadWritingFileForm.successful) && !['submitted'].includes(subtestAttempt.status)">
          <i class="fas fa-check-circle"></i> {{ translate('subtest-attempt.file_uploaded_successfully') }}
        </div>

        <div class="alert alert-danger" role="alert" v-if="uploadListeningFileForm.errors.has('file')">
          <i class="fa fa-warning"></i> {{ uploadListeningFileForm.errors.get('file') }}
        </div>

        <div class="alert alert-warning" role="alert"
             v-if="['submitted', 'completed'].includes(subtestAttempt.status) && ['speaking', 'complete'].includes(subtestAttempt.subtest.subtest_type.name)">
          <i class="fa fa-warning"></i> {{ translate('subtest-attempt.exam_start') }}: {{ examStart }}
        </div>

        <h2>{{ translate('subtest-attempt.download_material') }}</h2>

        <div v-if="['writing', 'complete'].includes(subtestAttempt.subtest.subtest_type.name)">
          <div class="alert alert-success" role="alert" v-if="['submitted'].includes(subtestAttempt.status)">
            <i class="fas fa-check-circle"></i> {{ translate('subtest-attempt.1_week_notice') }}
          </div>

          <div class="block-style shadow-sm" :class="readingBlockClass">
            <div class="block-style-img">
              <img src="/images/icon1.svg" alt="reading">
            </div>
            <div class="block-style-content">
              <h4>{{ translate('subtest-attempt.reading') }}</h4>
              <p>
                <span v-html="subtestAttempt.subtest['reading_description_' + app.locale]"></span>
                <br>
                <strong>
                  {{ translate('subtest-attempt.duration') + ' : ' + subtestAttempt.subtest.reading_duration + ' ' + translate('subtest-attempt.minutes') }}
                </strong>
              </p>

              <div v-if="subtestAttempt.writing_status === 'cancelled'">
                <h5 class="text-danger">Abgesagt</h5>
              </div>
              <ul v-else class="list-group list-group-flush" style="font-size: 16px">
                <li class="list-group-item">
                  <number-icon :number="1"></number-icon>
                  {{ translate('subtest-attempt.download_material') }}:

                  <span v-for="file in subtestAttempt.subtest.reading_files" class="mb-0">
                      <a :href="file.url"
                         :download="file.original_name">
                          <i v-if="file.mime_type === 'application/pdf'"
                             class="fas fa-file-pdf text-danger"></i>
                          <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                          {{ file.original_name }}

                          <i class="fa fa-download"></i>
                      </a>
                      <br>
                  </span>
                </li>
                <li class="list-group-item">
                  <number-icon :number="2"></number-icon>
                  {{ translate('subtest-attempt.read_fill_scan') }}
                </li>
                <li class="list-group-item" v-if="!readyForSubmit">
                  <number-icon :number="3"></number-icon>
                  {{ translate('subtest-attempt.save_your_result') }}:

                  <form role="form" class="upload-file-form">
                    <input ref="reading_file"
                           type="file"
                           name="reading_file"
                           @change="uploadFile('reading')"
                           :disabled="uploadReadingFileForm.busy">
                  </form>
                </li>

                <li class="list-group-item" v-if="subtestAttempt.submitted_reading_files.length > 0">
                  <number-icon :number="4"></number-icon>
                  {{ translate('subtest-attempt.your_submitted_file') }}:

                  <span class="mb-0">
                      <a :href="subtestAttempt.submitted_reading_files[0].url"
                         :download="subtestAttempt.submitted_reading_files[0].original_name">
                          <i class="fas fa-file-pdf text-danger"></i>
                          {{ subtestAttempt.submitted_reading_files[0].original_name }}

                          <i class="fa fa-download"></i>
                      </a>
                      <br>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="alert alert-info mt-5" role="alert" v-if="showReadingGrade">
            <h4 class="alert-heading">
              <i class="fas fa-info-circle"></i>
              {{ translate('subtest-attempt.reading_grade_heading') }}
            </h4>
            <hr>
            {{ translate('subtest-attempt.grade') }}: {{ subtestAttempt.reading_grade }}
          </div>

          <div class="block-style shadow-sm" :class="listeningBlockClass">
            <div class="block-style-img">
              <img src="/images/icon2.svg" alt="listening">
            </div>
            <div class="block-style-content">
              <h4>{{ translate('subtest-attempt.listening') }}</h4>
              <p><span v-html="subtestAttempt.subtest['listening_description_' + app.locale]"></span><br>
                <strong>{{ translate('subtest-attempt.duration') + ' : ' + subtestAttempt.subtest.listening_duration + ' ' + translate('subtest-attempt.minutes') }}</strong>
              </p>

              <div v-if="subtestAttempt.writing_status === 'cancelled'">
                <h5 class="text-danger">Abgesagt</h5>
              </div>
              <ul v-else class="list-group list-group-flush" style="font-size: 16px">
                <li class="list-group-item">
                  <number-icon :number="1"></number-icon>
                  {{ translate('subtest-attempt.download_material') }}:

                  <span v-for="file in subtestAttempt.subtest.listening_files" class="mb-0">
                      <a :href="file.url"
                         :download="file.original_name">
                          <i v-if="file.mime_type === 'application/pdf'"
                             class="fas fa-file-pdf text-danger"></i>
                          <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                          {{ file.original_name }}

                          <i class="fa fa-download"></i>
                      </a>
                      <br>
                  </span>
                </li>
                <li class="list-group-item">
                  <number-icon :number="2"></number-icon>
                  {{ translate('subtest-attempt.listen_fill_scan') }}
                </li>
                <li class="list-group-item" v-if="!readyForSubmit">
                  <number-icon :number="3"></number-icon>
                  {{ translate('subtest-attempt.save_your_result') }}:

                  <form role="form" class="upload-file-form">
                    <input ref="listening_file"
                           type="file"
                           name="listening_file"
                           @change="uploadFile('listening')"
                           :disabled="uploadListeningFileForm.busy">
                  </form>
                </li>

                <li class="list-group-item" v-if="subtestAttempt.submitted_listening_files.length > 0">
                  <number-icon :number="4"></number-icon>
                  {{ translate('subtest-attempt.your_submitted_file') }}:

                  <span class="mb-0">
                      <a :href="subtestAttempt.submitted_listening_files[0].url"
                         :download="subtestAttempt.submitted_listening_files[0].original_name">
                          <i class="fas fa-file-pdf text-danger"></i>
                          {{ subtestAttempt.submitted_listening_files[0].original_name }}

                          <i class="fa fa-download"></i>
                      </a>
                      <br>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="alert alert-info mt-5" role="alert" v-if="showListeningGrade">
            <h4 class="alert-heading">
              <i class="fas fa-info-circle"></i>
              {{ translate('subtest-attempt.listening_grade_heading') }}
            </h4>
            <hr>
            {{ translate('subtest-attempt.grade') }}: {{ subtestAttempt.listening_grade }}
          </div>

          <div class="block-style shadow-sm" :class="writingBlockClass">
            <div class="block-style-img">
              <img src="/images/icon3.svg" alt="writing">
            </div>
            <div class="block-style-content">
              <h4>{{ translate('subtest-attempt.writing') }}</h4>
              <p><span v-html="subtestAttempt.subtest['writing_description_' + app.locale]"></span><br>
                <strong>
                  {{ translate('subtest-attempt.duration') + ' : ' + subtestAttempt.subtest.writing_duration + ' ' + translate('subtest-attempt.minutes') }}
                </strong>
              </p>

              <div v-if="subtestAttempt.writing_status === 'cancelled'">
                <h5 class="text-danger">Abgesagt</h5>
              </div>
              <ul v-else class="list-group list-group-flush" style="font-size: 16px">
                <li class="list-group-item">
                  <number-icon :number="1"></number-icon>
                  {{ translate('subtest-attempt.download_material') }}:

                  <span v-for="file in subtestAttempt.subtest.writing_files" class="mb-0">
                      <a :href="file.url"
                         :download="file.original_name">
                          <i v-if="file.mime_type === 'application/pdf'"
                             class="fas fa-file-pdf text-danger"></i>
                          <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                          {{ file.original_name }}

                          <i class="fa fa-download"></i>
                      </a>
                      <br>
                  </span>
                </li>
                <li class="list-group-item">
                  <number-icon :number="2"></number-icon>
                  {{ translate('subtest-attempt.read_fill_scan') }}
                </li>
                <li class="list-group-item" v-if="!readyForSubmit">
                  <number-icon :number="3"></number-icon>
                  {{ translate('subtest-attempt.save_your_result') }}:

                  <form role="form" class="upload-file-form">
                    <input ref="writing_file"
                           type="file"
                           name="writing_file"
                           @change="uploadFile('writing')"
                           :disabled="uploadWritingFileForm.busy">
                  </form>
                </li>

                <li class="list-group-item" v-if="subtestAttempt.submitted_writing_files.length > 0">
                  <number-icon :number="4"></number-icon>
                  {{ translate('subtest-attempt.your_submitted_file') }}:

                  <span class="mb-0">
                      <a :href="subtestAttempt.submitted_writing_files[0].url"
                         :download="subtestAttempt.submitted_writing_files[0].original_name">
                          <i class="fas fa-file-pdf text-danger"></i>
                          {{ subtestAttempt.submitted_writing_files[0].original_name }}

                          <i class="fa fa-download"></i>
                      </a>
                      <br>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="alert alert-info mt-5" role="alert" v-if="showWritingGrade">
            <h4 class="alert-heading">
              <i class="fas fa-info-circle"></i>
              {{ translate('subtest-attempt.writing_grade_heading') }}
            </h4>
            <hr>
            {{ translate('subtest-attempt.grade') }}: {{ subtestAttempt.writing_grade }}
          </div>

          <button v-if="!['cancelled', 'cancellation-requested'].includes(subtestAttempt.writing_status)"
                  @click="showCancelWritingModal" class="btn btn-sm btn-outline-danger mt-3">
            {{ translate('subtest-attempt.cancellation.request_writing_cancellation') }}
          </button>

          <div class="mt-3" v-if="subtestAttempt.writing_status === 'cancellation-requested'">
            <h5 class="text-danger">Stornierung schriftlich beantragt</h5>
          </div>
        </div>

        <div class="alert alert-success" role="alert" v-if="submitSubtestAttemptForm.successful">
          <i class="fas fa-check-circle"></i>
          {{ translate('subtest-attempt.documents_submitted_successfully') }}
        </div>

        <div class="card bg-light mt-3" v-if="showSubmitWrittenButton">
          <button
            class="btn btn-primary"
            @click="submit"
            :disabled="!readyForSubmit || submitSubtestAttemptForm.busy">
            {{ translate('subtest-attempt.submit_all_documents') }}
          </button>
        </div>

        <div class="alert alert-info mt-5" role="alert" v-if="showWritingModuleGrade">
          <h4 class="alert-heading">
            <i class="fas fa-info-circle"></i>
            {{ translate('subtest-attempt.writing_module_grade_heading') }}
          </h4>
          <hr>
          {{ translate('subtest-attempt.grade') }}: {{ subtestAttempt.writing_module_grade }}
        </div>

        <div class="clearfix"></div>

        <div v-if="['speaking', 'complete'].includes(subtestAttempt.subtest.subtest_type.name)">
          <div class="block-style shadow-sm" :class="speakingBlockClass">
            <div class="block-style-img">
              <img src="/images/icon4.svg" alt="speaking">
            </div>
            <div class="block-style-content">
              <h4>{{ translate('subtest-attempt.speaking') }}</h4>
              <p>
                <span v-html="subtestAttempt.subtest['speaking_description_' + app.locale]"></span>
                <br>
                <strong>
                  {{ translate('subtest-attempt.duration') + ' : ' + subtestAttempt.subtest.speaking_duration + ' ' + translate('subtest-attempt.minutes') }}
                </strong>
              </p>

              <div v-if="subtestAttempt.speaking_status === 'cancelled'">
                <h5 class="text-danger">Abgesagt</h5>
              </div>
              <ul v-else class="list-group list-group-flush" style="font-size: 16px">
                <li class="list-group-item">
                  <number-icon :number="1"></number-icon>
                  {{ translate('subtest-attempt.download_material') }}:

                  <span v-for="file in subtestAttempt.subtest.speaking_files" class="mb-0">
                                        <a :href="file.url"
                                           :download="file.original_name">
                                            <i v-if="file.mime_type === 'application/pdf'"
                                               class="fas fa-file-pdf text-danger"></i>
                                            <i v-if="file.mime_type === 'audio/mpeg'" class="fas fa-file-audio"></i>
                                            {{ file.original_name }}

                                            <i class="fa fa-download"></i>

                                        </a>
                                        <br>
                                    </span>
                </li>
                <li class="list-group-item">
                  <number-icon :number="2"></number-icon>
                  {{ translate('subtest-attempt.read_prepare') }}
                </li>
                <li class="list-group-item">
                  <number-icon :number="3"></number-icon>
                  {{ translate('subtest-attempt.speaking_block.meet_instructor') }}
                  <ul class="mt-2">
                    <li>
                        {{ translate('subtest-attempt.speaking_block.time') }}: {{ subtestAttempt.speaking_appointment_at | datetime }}
                    </li>
                    <li>{{ translate('subtest-attempt.speaking_block.line_1') }}</li>
                    <li>{{ translate('subtest-attempt.speaking_block.line_2') }}:</li>
                    <li>
                        {{ translate('subtest-attempt.speaking_block.platform') }}: {{ subtestAttempt.platform | capitalize }}
                    </li>
                    <li>
                        {{ translate('subtest-attempt.speaking_block.link') }}: {{ subtestAttempt.platform_id }}
                    </li>
                  </ul>

                </li>
              </ul>

              <button
                v-if="!['cancelled', 'cancellation-requested'].includes(subtestAttempt.speaking_status)"
                @click="showCancelSpeakingModal" class="btn btn-sm btn-outline-danger">
                {{ translate('subtest-attempt.cancellation.request_speaking_cancellation') }}
              </button>

              <div v-if="subtestAttempt.speaking_status === 'cancellation-requested'">
                <h5 class="text-danger">Stornierung zum Sprechen beantragt</h5>
              </div>
            </div>
          </div>
        </div>

        <div class="alert alert-info mt-5" role="alert" v-if="showSpeakingGrade">
          <h4 class="alert-heading">
            <i class="fas fa-info-circle"></i> {{ translate('subtest-attempt.speaking_grade_heading') }}
          </h4>
          <hr>
          {{ translate('subtest-attempt.grade') }}: {{ subtestAttempt.speaking_grade }}
        </div>

        <div class="alert alert-info mt-5" role="alert" v-if="showSpeakingModuleGrade">
          <h4 class="alert-heading">
            <i class="fas fa-info-circle"></i>
            {{ translate('subtest-attempt.speaking_module_grade_heading') }}
          </h4>
          <hr>
          {{ translate('subtest-attempt.grade') }}: {{ subtestAttempt.speaking_module_grade }}
        </div>

        <div class="alert alert-info mt-5" role="alert" v-if="showFeedback">
          <h4 class="alert-heading">
            <i class="fas fa-info-circle"></i> {{ translate('subtest-attempt.feedback_heading') }}
          </h4>
          <hr>
          {{ translate('subtest-attempt.feedback') }}: {{ subtestAttempt.notes }}
          <hr>

          {{ translate('subtest-attempt.completed_file_heading') }}

          <p class="mb-0">
            <a :href="subtestAttempt.completed_files[0].url"
               :download="subtestAttempt.completed_files[0].original_name">
              <i class="fas fa-file-pdf"></i>
              {{ subtestAttempt.completed_files[0].original_name }}

              <i class="fa fa-download"></i>
            </a>
            <br>
          </p>
        </div>
      </div>
    </div>

    <div class="modal"
         id="modal-cancel-subtest-attempt-speaking"
         tabindex="-1"
         role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ translate('modals.cancellation.title') }}
            </h5>
          </div>

          <div class="modal-body">
            <div class="alert alert-warning">
              <i class="fa fa-warning"></i>
              <span v-if="subtestAttempt.speaking_didnt_pass_deadline">
                  {{ translate('modals.cancellation.speaking_before_deadline_cancellation_warning') }}
              </span>
              <span v-if="subtestAttempt.speaking_passed_deadline">
                  {{ translate('modals.cancellation.speaking_after_deadline_cancellation_warning') }}
              </span>
              <span
                v-if="subtestAttempt.speaking_passed_appointment && subtestAttempt.speaking_status === 'student-absent'">
                  {{ translate('modals.cancellation.speaking_after_appointment_cancellation_warning') }}
              </span>
            </div>

            <form role="form">
              <div class="form-group row" v-if="!subtestAttempt.speaking_didnt_pass_deadline">
                <label class="col-md-4 col-form-label text-md-right" for="reading_grade">
                  {{ translate('modals.cancellation.form.reason') }}
                </label>

                <div class="col-md-6">
                    <textarea id="reading_grade"
                              class="form-control"
                              name="reading_grade"
                              v-model="cancelSubtestAttemptSpeakingForm.reason"
                              :class="{'is-invalid': cancelSubtestAttemptSpeakingForm.errors.has('reason')}">
                    </textarea>
                    <span class="invalid-feedback"
                          v-if="cancelSubtestAttemptSpeakingForm.errors.has('reason')">
                        <strong>{{ cancelSubtestAttemptSpeakingForm.errors.get('reason') }}</strong>
                    </span>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button"
                    class="btn btn-default"
                    data-dismiss="modal">
              {{ translate('modals.cancellation.cancel') }}
            </button>
            <button type="button"
                    class="btn btn-success"
                    @click.prevent="cancelSubtestAttempt('speaking')"
                    :disabled="cancelSubtestAttemptSpeakingForm.busy">
              {{ translate('modals.cancellation.submit') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal"
         id="modal-cancel-subtest-attempt-writing"
         tabindex="-1"
         role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ translate('modals.cancellation.title') }}
            </h5>
          </div>

          <div class="modal-body">
            <div class="alert alert-warning">
              <i class="fa fa-warning"></i>
              <span v-if="subtestAttempt.writing_passed_deadline">
                  {{ translate('modals.cancellation.writing_after_deadline_cancellation_warning') }}
              </span>
              <span v-else>
                  {{ translate('modals.cancellation.writing_before_deadline_cancellation_warning') }}
              </span>
            </div>

            <form role="form">
              <div class="form-group row" v-if="!subtestAttempt.speaking_didnt_pass_deadline">
                <label class="col-md-4 col-form-label text-md-right" for="writing_grade">
                  {{ translate('modals.cancellation.form.reason') }}
                </label>

                <div class="col-md-6">
                    <textarea id="writing_grade"
                              class="form-control"
                              name="writing_grade"
                              v-model="cancelSubtestAttemptWritingForm.reason"
                              :class="{'is-invalid': cancelSubtestAttemptWritingForm.errors.has('reason')}">
                    </textarea>
                    <span class="invalid-feedback"
                          v-if="cancelSubtestAttemptWritingForm.errors.has('reason')">
                        <strong>{{ cancelSubtestAttemptWritingForm.errors.get('reason') }}</strong>
                    </span>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button"
                    class="btn btn-default"
                    data-dismiss="modal">
              {{ translate('modals.cancellation.cancel') }}
            </button>
            <button type="button"
                    class="btn btn-success"
                    @click.prevent="cancelSubtestAttempt('writing')"
                    :disabled="cancelSubtestAttemptWritingForm.busy">
              {{ translate('modals.cancellation.submit') }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['subtestAttemptId'],

  mixins: [require('../../../../resources/js/mixin')],

  data () {
    return {
      subtestAttempt: null,
      uploadReadingFileForm: new AppForm({}),
      uploadListeningFileForm: new AppForm({}),
      uploadWritingFileForm: new AppForm({}),
      submitSubtestAttemptForm: new AppForm({}),

      cancelSubtestAttemptSpeakingForm: new AppForm({
        type: 'speaking',
        reason: null,
      }),

      cancelSubtestAttemptWritingForm: new AppForm({
        type: 'writing',
        reason: null,
      }),
    };
  },

  mounted () {
    this.getSubtestAttempt();
  },

  methods: {
    /**
     * Submit the Subtest Attempt.
     */
    submit () {
      let self = this;

      App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/submit', this.submitSubtestAttemptForm)
        .then(() => {
          self.submitSubtestAttemptForm.finishProcessing();
          window.location.href = '/subtest-attempts/' + this.subtestAttempt.id;
        });
    },

    uploadFile (type) {
      if (!this.$refs[type + '_file'].files.length) {
        return;
      }

      let self = this;
      let uploadFileForm;

      if (type === 'reading') {
        uploadFileForm = this.uploadReadingFileForm;
      } else if (type === 'listening') {
        uploadFileForm = this.uploadListeningFileForm;
      } else if (type === 'writing') {
        uploadFileForm = this.uploadWritingFileForm;
      } else {
        return;
      }

      uploadFileForm.startProcessing();

      // We need to gather a fresh FormData instance with the document file appended to
      // the data so we can POST it up to the server.
      let form = new FormData();
      form.append('file', this.$refs[type + '_file'].files[0]);
      form.append('subtest_attempt_id', this.subtestAttempt.id);
      form.append('subtest_type', type);

      axios.post('/files', form)
        .then((response) => {
          self.$refs[type + '_file'].value = '';
          uploadFileForm.finishProcessing();
          self.getSubtestAttempt();
        }, (error) => {
          uploadFileForm.setErrors(error.response.data.errors);
        });
    },

    /**
     * Get the specified SubtestAttempt.
     */
    getSubtestAttempt () {
      axios.get('/api/subtest-attempts/' + this.subtestAttemptId)
        .then(response => {
          this.subtestAttempt = response.data.subtestAttempt;
        });
    },

    /**
     * Cancel the Subtest Attempt.
     */
    cancelSubtestAttempt (type) {
      let self = this;

      if (type === 'speaking') {
        App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/request-cancellation', this.cancelSubtestAttemptSpeakingForm)
          .then(() => {
            $('#modal-cancel-subtest-attempt-speaking').modal('hide');
            self.getSubtestAttempt();
          });
      } else {
        App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/request-cancellation', this.cancelSubtestAttemptWritingForm)
          .then(() => {
            $('#modal-cancel-subtest-attempt-writing').modal('hide');
            self.getSubtestAttempt();
          });
      }

    },

    showCancelSpeakingModal () {
      $('#modal-cancel-subtest-attempt-speaking').modal('show');
    },

    showCancelWritingModal () {
      $('#modal-cancel-subtest-attempt-writing').modal('show');
    }
  },

  computed: {
    examStart: function () {
      return moment(this.subtestAttempt.speaking_appointment_at).fromNow();
    },

    showSubmitWrittenButton () {
      return !['submitted', 'completed'].includes(this.subtestAttempt.status) && this.subtestAttempt.subtest.subtest_type.name !== 'speaking';
    },

    writingDeadline () {
      return this.subtestAttempt.writing_deadline ? moment(this.subtestAttempt.writing_deadline).format('DD.MM YYYY') : '';
    },

    speakingDateDay () {
      return moment(this.subtestAttempt.speaking_appointment_at).format('DD ddd');
    },

    speakingDateMonth () {
      return moment(this.subtestAttempt.speaking_appointment_at).format('MMM');
    },

    speakingDateYear () {
      return moment(this.subtestAttempt.speaking_appointment_at).format('YYYY');
    },

    speakingDateHours () {
      return moment(this.subtestAttempt.speaking_appointment_at).format('HH a') + ' - ' + moment(this.subtestAttempt.speaking_appointment_at).add(1, 'h').format('HH a');
    },

    readingBlockClass () {
      if (this.subtestAttempt.writing_status === 'cancelled') {
        return 'error';
      }

      if (this.uploadReadingFileForm.successful || this.subtestAttempt.submitted_reading_files.length > 0) {
        return 'success';
      }

      if (this.uploadReadingFileForm.errors.has('file')) {
        return 'error';
      }

      return '';
    },

    listeningBlockClass () {
      if (this.subtestAttempt.writing_status === 'cancelled') {
        return 'error';
      }

      if (this.uploadListeningFileForm.successful || this.subtestAttempt.submitted_listening_files.length > 0) {
        return 'success';
      }

      if (this.uploadListeningFileForm.errors.has('file')) {
        return 'error';
      }

      return '';
    },

    writingBlockClass () {
      if (this.subtestAttempt.writing_status === 'cancelled') {
        return 'error';
      }

      if (this.uploadWritingFileForm.successful || this.subtestAttempt.submitted_writing_files.length > 0) {
        return 'success';
      }

      if (this.uploadWritingFileForm.errors.has('file')) {
        return 'error';
      }

      return '';
    },

    speakingBlockClass () {
      if (this.subtestAttempt.speaking_status === 'cancelled') {
        return 'error';
      }

      // if (this.subtestAttempt.speaking_status === '') {
      //     return 'success';
      // }

      return '';
    },

    readyForSubmit () {
      return this.subtestAttempt.submitted_reading_files.length > 0 &&
        this.subtestAttempt.submitted_listening_files.length > 0 &&
        this.subtestAttempt.submitted_writing_files.length > 0;
    },

    showWritingModuleGrade () {
      if (this.subtestAttempt.subtest.grading_by_subtest_type) {
        return false;
      }

      if (this.subtestAttempt.subtest.subtest_type_id === 3) {
        return this.subtestAttempt.status === 'completed' && this.subtestAttempt.writing_module_grade;
      }

      if (this.subtestAttempt.subtest.subtest_type_id === 5) {
        return this.subtestAttempt.writing_module_grade;
      }

      return false;
    },

    showSpeakingModuleGrade () {
      if (this.subtestAttempt.subtest.grading_by_subtest_type) {
        return false;
      }

      if ([4, 5].includes(this.subtestAttempt.subtest.subtest_type_id)) {
        return this.subtestAttempt.speaking_module_grade && this.subtestAttempt.speaking_module_grade !== '';
      }

      return false;
    },

    showSpeakingGrade () {
      if (!this.subtestAttempt.subtest.grading_by_subtest_type) {
        return false;
      }

      if ([4, 5].includes(this.subtestAttempt.subtest.subtest_type_id)) {
        return this.subtestAttempt.speaking_module_grade;
      }

      return false;
    },

    showListeningGrade () {
      if (!this.subtestAttempt.subtest.grading_by_subtest_type) {
        return false;
      }

      if ([3, 5].includes(this.subtestAttempt.subtest.subtest_type_id)) {
        return this.subtestAttempt.listening_grade;
      }

      return false;
    },

    showWritingGrade () {
      if (!this.subtestAttempt.subtest.grading_by_subtest_type) {
        return false;
      }

      if ([3, 5].includes(this.subtestAttempt.subtest.subtest_type_id)) {
        return this.subtestAttempt.writing_grade;
      }

      return false;
    },

    showReadingGrade () {
      if (!this.subtestAttempt.subtest.grading_by_subtest_type) {
        return false;
      }

      if ([3, 5].includes(this.subtestAttempt.subtest.subtest_type_id)) {
        return this.subtestAttempt.reading_grade;
      }

      return false;
    },

    showFeedback () {
      return this.subtestAttempt.status === 'completed';
    },

    showSpeakingAfterDeadlineCancellationWarning () {
      return !this.subtestAttempt.speaking_is_week_before
        && !this.subtestAttempt.speaking_is_passed;
    },

    showSpeakingPassedCancellationWarning () {
      return this.subtestAttempt.speaking_is_passed
        && this.subtestAttempt.speaking_status === 'student-absent';
    }
  }
};
</script>

<style>
.block-style.success {
    border: 1px solid #38c172;
    border-left: 8px solid #38c172;
}

.block-style.error {
    border: 1px solid #e3342f;
    border-left: 8px solid #e3342f;
}

.block-style {
    border-radius: 4px;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.upload-file-form {
    margin-top: 10px
}
</style>
